/*
  Global Tools — ficha de producto (sections/gt-product.liquid).
  Reemplaza los scripts que repetía cada ficha especial. Todo es mejora
  progresiva: sin JavaScript la galería, las variantes y el formulario
  funcionan con HTML nativo.

  - Variante elegida → precio, precio tachado, referencia, barra fija,
    mensaje de WhatsApp, foto de la variante y ?variant= en la dirección.
  - Galería: miniatura activa al desplazar o tocar.
  - Barra fija de móvil: aparece al pasar el botón principal y se oculta al
    llegar a relacionados o al footer; sus botones delegan en los reales.
*/
(() => {
  const init = (root) => {
    const form = root.querySelector('.gt-pdp__form');
    const price = root.querySelector('[data-gt-price]');
    const compare = root.querySelector('[data-gt-compare]');
    const slides = root.querySelector('[data-gt-slides]');
    const thumbs = [...root.querySelectorAll('.gt-pdp__thumb')];
    const sticky = root.querySelector('[data-gt-sticky]');
    const mainAction = root.querySelector('[data-gt-main-add]') || root.querySelector('.gt-advice a');

    /* ---- Galería ---- */
    const setActive = (mediaId) => {
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId)));
    };
    const showMedia = (mediaId) => {
      if (!slides || !mediaId) return;
      const slide = slides.querySelector(`[data-media-id="${mediaId}"]`);
      if (!slide) return;
      slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      setActive(mediaId);
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => setActive(thumb.dataset.mediaId)));
    if (slides && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.dataset.mediaId); });
      }, { root: slides, threshold: 0.6 });
      slides.querySelectorAll('[data-media-id]').forEach((s) => io.observe(s));
    }

    /* ---- Variantes ---- */
    // Enlaces de cotización de la ficha: el mensaje base se guarda sin la
    // referencia inicial y se rearma con la variante elegida.
    const quoteLinks = [...root.querySelectorAll('a[href*="wa.me"][data-gt-lead^="ficha_"]')];
    const baseMessages = new WeakMap();
    quoteLinks.forEach((link) => {
      try {
        const text = new URL(link.href).searchParams.get('text') || '';
        baseMessages.set(link, text.replace(/\s*\(Ref\.[\s\S]*\)\s*$/, ''));
      } catch (e) { /* enlace sin URL válida */ }
    });

    const selected = () => {
      if (!form) return null;
      const radio = form.querySelector('input[name="id"]:checked');
      if (radio) return { id: radio.value, ...radio.dataset };
      const select = form.querySelector('select[name="id"]');
      if (select) {
        const opt = select.options[select.selectedIndex];
        return { id: opt.value, ...opt.dataset };
      }
      return null;
    };

    const applyVariant = () => {
      const v = selected();
      if (!v) return;
      if (price && v.price) price.textContent = v.price;
      if (compare) {
        compare.textContent = v.compare || '';
        compare.hidden = !v.compare;
      }
      root.querySelectorAll('[data-gt-sku-text]').forEach((el) => { el.textContent = v.sku || ''; });
      root.querySelectorAll('[data-gt-variant-name]').forEach((el) => { el.textContent = (v.title || '').replace(/"/g, '″'); });
      const stickyPrice = root.querySelector('[data-gt-sticky-price]');
      if (stickyPrice && v.price) stickyPrice.textContent = v.price;
      const stickyLabel = root.querySelector('[data-gt-sticky-label]');
      if (stickyLabel && v.title) {
        const rest = stickyLabel.textContent.split(' · ').slice(1);
        stickyLabel.textContent = [v.title, ...rest].join(' · ');
      }
      quoteLinks.forEach((link) => {
        if (!baseMessages.has(link)) return;
        try {
          const url = new URL(link.href);
          let text = baseMessages.get(link);
          if (v.title) text += ` — Variante: ${v.title}`;
          if (v.sku) text += ` (Ref. ${v.sku})`;
          url.searchParams.set('text', text);
          link.href = url.toString();
        } catch (e) { /* enlace sin URL válida */ }
      });
      showMedia(v.mediaId);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    };
    if (form) form.addEventListener('change', (e) => { if (e.target.name === 'id') applyVariant(); });

    /* ---- Barra fija ---- */
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-gt-sticky-add]')) {
        const add = root.querySelector('[data-gt-main-add]');
        if (add && !add.disabled) add.click();
      }
      if (e.target.closest('[data-gt-advice-trigger]')) {
        root.querySelector('.gt-advice a')?.click();
      }
    });

    if (!sticky || !mainAction) return;
    let pending = false;
    const update = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        const past = mainAction.getBoundingClientRect().bottom < 0;
        const box = sticky.getBoundingClientRect();
        const stop = [root.querySelector('.gt-product__related'), document.querySelector('.gt-footer')]
          .some((el) => el && el.getBoundingClientRect().top < box.bottom + 16);
        sticky.classList.toggle('is-visible', past && !stop);
      });
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  document.querySelectorAll('[data-gt-pdp]').forEach(init);
})();
